<div class="object-content-tabs-container">
  <div class="object-content-tabs">
    <ul
      class="object-content-tabs__main-tabs"
      #menuControl
      [ngClass]="{'loadedMenu': contentInfo.menus && contentInfo.selectedMainMenu}"
      [@slideInContentTab]="contentInfo.menus && contentInfo.menus.length"
    >
      @for (menu of contentInfo.menus; track $index) {
        <app-object-content-main-tab
          class="tab"
          [invisible]="contentInfo.visibleDropDowns[i]"
          [menu]="menu"
          [isEditing]="isEditing"
          (menuOpened)="openMenu(menu)"
        ></app-object-content-main-tab>
      }

      @if (menuItemsReady && menuItems) {
        <app-object-content-dropdown-menu
          class="tab"
          [contentInfo]="contentInfo"
          [menuItems]="menuItems"
          [myRoot]="myRoot"
          [selectedMainMenu]="contentInfo.selectedMainMenu"
          [isEditing]="isEditing"
          (menuOpened)="openMenu($event)"
        ></app-object-content-dropdown-menu>
      }
    </ul>

    @if (contentInfo.selectedMainMenu && contentInfo.selectedMainMenu[AConst.SUB_MENUS]) {
      <ul class="object-content-tabs__sub-tabs">
        @for (subMenu of contentInfo.selectedMainMenu[AConst.SUB_MENUS]; track $index) {
          <li>
            <a
              (click)="openMenu(subMenu)"
              class="object-content-tabs__sub-tab-item text-dark-primary-hover"
              [ngClass]="{'active-subMenu': subMenu.open}"
            >
              <span
                class="object-content-tabs__sub-tab-text object-content-tab-text"
                [class.text-primary]="subMenu.open"
              >
                <i class="{{subMenu.icon}}"></i>

                <span
                  class="object-content-tabs__sub-tab-caption"
                  [ngClass]="{'bold': subMenu.open}" [translate]="subMenu.caption"
                ></span>

                @if (subMenu.count) {
                  <span class="object-content-tab-count">
                    <span class="text-primary">
                      {{subMenu.count}}
                    </span>
                  </span>
                }
              </span>
            </a>
          </li>
        }
      </ul>
    }
  </div>
</div>
